module.exports = __webpack_public_path__ + "static/media/alert.0f496ccc.mp3";